<template>
    <ul id="ulBudgetList">
        <li v-for="budget in formattedBudgets" :key="budget.name">
            <div>
                <div class="name">
                    <span>{{budget.name}}</span>
                </div>
                <div class="amount">
                    <span>{{budget.amount.toFixed(2)}}</span>
                </div>
                <div class="progress">
                    <step-progress :options="{
                        total: budget.amount,
                        value: [budget.used, budget.pending ]
                        // value: [budget.used, budget.pending , budget.procureUsed , budget.procurePending]
                    }"></step-progress>
                </div>
                <div class="description">
                    <ul>
                        <li>
                            采购已占用：{{budget.procureUsed.toFixed(2)}}（{{budget.procureUsedPercent}}%）
                        </li>
                        <li>
                            可用剩余：{{budget.procureBalance.toFixed(2)}}（{{budget.procureBalancePercent}}%）
                        </li>
                        <li>
                            审批中支出：{{budget.pending.toFixed(2)}}（{{budget.pendingPercent}}%）
                        </li>
                        <li>
                            付款已支出：{{budget.used.toFixed(2)}}（{{budget.usedPercent}}%）
                        </li>
                        <li>
                            实际剩余：{{budget.balance.toFixed(2)}}（{{budget.balancePercent}}%）
                        </li>
                       
                    </ul>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
    import StepProgress from "../../components/StepProgress";
    import budgetService from "../../service/budgetService";
    import _ from "lodash";


    export default {
        components: {StepProgress},
        computed: {
            formattedBudgets() {
                return [this.summary].concat(...this.budgets).map(budget => {
                    let balance = budget.amount - budget.used - budget.pending;
                    let procureBalance =  budget.amount - budget.procureUsed - budget.procurePending- budget.used - budget.pending;
                    return {
                        name: budget.name,
                        amount: budget.amount,
                        used: budget.used,
                        pending: budget.pending,
                        balance: balance,
                        procureUsed: budget.procureUsed,
                        procurePending: budget.procurePending,
                        procureBalance: procureBalance,
                        usedPercent: _.round(budget.amount === 0 ? 0 : budget.used * 100 / budget.amount, 2),
                        pendingPercent: _.round(budget.amount === 0 ? 0 : budget.pending * 100 / budget.amount, 2),
                        balancePercent: _.round(budget.amount === 0 ? 0 : balance * 100 / budget.amount, 2),

                        procureUsedPercent: _.round(budget.amount === 0 ? 0 : budget.procureUsed * 100 / budget.amount, 2),
                        procurePendingPercent: _.round(budget.amount === 0 ? 0 : budget.procurePending * 100 / budget.amount, 2),
                        procureBalancePercent: _.round(budget.amount === 0 ? 0 : procureBalance * 100 / budget.amount, 2)
                    }
                });
            },
            summary() {
                let amount = this.budgets.map(item => item.amount).reduce((acc, val) => acc + val, 0);
                let used = this.budgets.map(item => item.used).reduce((acc, val) => acc + val, 0);
                let pending = this.budgets.map(item => item.pending).reduce((acc, val) => acc + val, 0);
                let procureUsed = this.budgets.map(item => item.procureUsed).reduce((acc, val) => acc + val, 0);
                let procurePending = this.budgets.map(item => item.procurePending).reduce((acc, val) => acc + val, 0);
                return {
                    name: '预算总金额',
                    amount: amount,
                    used: used,
                    pending: pending,
                    procureUsed: procureUsed,
                    procurePending: procurePending
                };
            }
        },
        data() {
            return {
                budgets: []
            };
        },
        async mounted() {
            let resp = await budgetService.getExpense(this.$route.query.projectId);
            if (resp.data.Status === '1'){
                this.budgets = resp.data.Data;
            }
        }
    };
</script>
<style scoped>
    #ulBudgetList, .description > ul {
        list-style: none;
    }

    #ulBudgetList > li {
        margin-bottom: 24px;
    }

    #ulBudgetList > li > div {
        align-items: center;
        flex-direction: row;
        display: inline-flex;
    }

    #ulBudgetList > li:first-child > div > .name, #ulBudgetList > li:first-child > div > .amount {
        font-weight: bold;
    }

    .name, .amount {
        line-height: 21px;
        width: 120px;
    }

    .name {
        text-align: right;
    }

    .amount {
        text-align: center;
    }

    .progress {
        width: 400px;
    }

    .description {
        width: 280px;
        text-align: left;
    }

    .description > ul > li {
        line-height: 28px;
    }
</style>